<template>
  <v-content id="fileManager">
    <app-loading-overlay></app-loading-overlay>

    <v-container class="color1 pageHeader">
      <v-row>
        <v-col cols="12">
          <div class="text-center align-end justify-end">
            <h1 class="display-1">File Manager</h1>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div class="fileManagerHeader">
      <v-row>
        <v-col cols="12" class="fileManagerHeaderCol">
          <h4>Welcome, {{user.firstName}} {{user.lastName}}</h4>
          <span>You are logged in as administrator.</span>
          <hr />
        </v-col>
      </v-row>
    </div>

    <v-card class="fileExplorer" tile>
      <explorer-toolbar></explorer-toolbar>
      <v-row>
        <v-col sm="auto">
          <explorer-tree></explorer-tree>
        </v-col>
        <v-divider vertical color="black"></v-divider>
        <v-col>
          <explorer-file-list></explorer-file-list>
        </v-col>
      </v-row>
    </v-card>
  </v-content>
</template>

<script>
import ExplorerToolbar from "@/components/fileManager/ExplorerToolbar";
import ExplorerTree from "@/components/fileManager/ExplorerTree";
import ExplorerFileList from "@/components/fileManager/ExplorerFileList";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  name: "FileManager",
  components: {
    explorerToolbar: ExplorerToolbar,
    explorerTree: ExplorerTree,
    explorerFileList: ExplorerFileList
  },
  methods: {
    ...mapActions([
      "fetchFileContainerFromDatabase",
      "fetchAllUsersFromDB"
    ])
  },
  beforeMount() {
    this.fetchFileContainerFromDatabase();
    this.fetchAllUsersFromDB();
    //clear folder selection
  },
  computed: {
    ...mapGetters(["user"])
  },
  mounted() {
    this.logEvent("page_load", { 
      pageName: "fileManager",
      lang: this.$i18n.locale
     });
  },
};
</script>

<style scoped>
#fileManager {
  padding-top: 0px !important;
}
.fileExplorer {
  margin: 20px !important;
}
.fileContainer {
  margin: 0px !important;
}
.fileManagerHeader {
  margin-right: 20px;
  margin-left: 20px;
  margin-top: 0px;
  max-width: 100% !important;
  padding: 0;
}
.fileManagerHeaderCol {
  max-width: 100% !important;
}
</style>
